(function () {
  if (!document.body.classList.contains('template-product')) return;

  function initGalleryEnhancements() {
    const gallery = document.querySelector('media-gallery');
    const viewer = gallery?.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const slides = viewer.querySelectorAll('.product__media-item');
    const total = slides.length;
    if (total <= 1) return;

    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'zeno-gallery-dots';
    dotsContainer.setAttribute('role', 'tablist');
    dotsContainer.setAttribute('aria-label', 'Product image pagination');

    const dots = [];

    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'zeno-gallery-dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Image ' + (index + 1));
      dot.addEventListener('click', () => {
        const slide = slides[index];
        if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dots.push(dot);
      dotsContainer.appendChild(dot);
    });

    viewer.insertAdjacentElement('afterend', dotsContainer);

    function setActiveDot(page) {
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === page - 1);
      });
    }

    viewer.addEventListener('slideChanged', (event) => {
      setActiveDot(event.detail.currentPage);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryEnhancements);
  } else {
    initGalleryEnhancements();
  }
})();
